import { httpApi } from '@app/api/http.api';

export const getCatalogoEstados = (): Promise<any> =>
  httpApi.get<any>(`/catalogo/getEntidades`).then(({ data }) => data);

export const getCatalogoMunicipios = (id_estado: number): Promise<any> =>
  httpApi.get<any>(`/catalogo/getMunicipios/${id_estado}`).then(({ data }) => data);
